import Main from '@/components/main'
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          notCache: true,
          icon: '_shouye',
          title: 'Home - 首页',
        },
        component: () => import('@/views/single-page/home')
      }
    ]
  },
/*   {
    path: '/unionpay',
    name: 'unionpay',
    component: Main,
    meta: {
      icon: '_shanghupiliangruzhu',
      title: 'unionpay',
      hide: true,
      showAlways: false,
      access: ['query-role']
    },
    children: [
    {
        path: '/unionpay/signed-on',
        name: 'unionpay_signed_on',
        meta: {
          icon: '_shanghupiliangruzhu',
          title: 'unionpay_signed_on',
          access: ['query-role']
        },
        component: () => import('@/views/unionpay/UnionpaySigned')
       },
    ]
  }, */
    
  {
    path: '/operator',
    name: 'operator',
    component: Main,
    meta: {
      icon: '_yunyingyonghuguanli',
      title: 'operator',
      access: ['query-regional-operator', 'query-team-leader', 'query-operator', 'coach-list','user-query', 'student-query']
    },
    children: [
      
      {
        path: '/operator/merchant',
        name: 'operator_merchant_management',
        meta: {
          icon: '_yunyingshang',
          title: 'operator_merchant_management',
          access: ['query-regional-operator']
        },
        component: () => import('@/views/operator/MerchantManagement')
       },
      {
        path: '/operator/master',
        name: 'operator_master_management',
        meta: {
          icon: '_tuanchangguanli',
          title: 'operator_master_management',
          access: ['query-team-leader']
        },
        component: () => import('@/views/operator/MasterManagement')
       },
    {
        path: '/operator/leader',
        name: 'operator_leader_management',
        meta: {
          icon: '_zhuliren',
          title: 'operator_leader_management',
          access: ['query-operator']
        },
        component: () => import('@/views/operator/LeaderManagement')
       },
       {
        path: '/operator/coach',
        name: 'operator_coach_management',
        meta: {
          icon: '_jiaolian',
          title: 'operator_coach_management',
          access: ['coach-list']
        },
        component: () => import('@/views/operator/CoachManagement')
       },
       {
        path: '/operator/user',
        name: 'operator_user_management',
        meta: {
          icon: '_yonghu',
          title: 'operator_user_management',
          access: ['user-query']
        },
        component: () => import('@/views/operator/UserManagement')
       },
       {
        path: '/operator/student',
        name: 'operator_student_management',
        meta: {
          icon: '_haizi',
          title: 'operator_student_management',
          access: ['student-query']
        },
        component: () => import('@/views/operator/StudentManagement')
       }
       
    ]
  },

  {
    path: '/classes',
    name: 'classes',
    component: Main,
    meta: {
      icon: '_spellList',
      title: 'classes',
      access: ['course-query', 'scheduling-list', 'lesson-query', 'community-list','coach-calendar-list', 'lesson-package-query']
    },
    children: [
      
      {
        path: '/classes/course',
        name: 'classes_course',
        meta: {
          icon: '_557kechengleixing',
          title: 'classes_course',
          access: ['course-query']
        },
        component: () => import('@/views/classes/Course')
       },
       {
        path: '/classes/scheduling',
        name: 'classes_scheduling',
        meta: {
          icon: '_paibanguanli',
          title: 'classes_scheduling',
          access: ['scheduling-list']
        },
        component: () => import('@/views/classes/Scheduling')
       },
       {
        path: '/classes/lesson-package',
        name: 'classes_lesson_package',
        meta: {
          icon: '_spellList',
          title: 'classes_lesson_package',
          access: ['lesson-package-query']
        },
        component: () => import('@/views/classes/LessonPackage')
       },
       {
        path: '/classes/list',
        name: 'classes_list',
        meta: {
          icon: '_banjiketang',
          title: 'classes_list',
          access: ['lesson-query']
        },
        component: () => import('@/views/classes/List')
       },
      {
        path: '/classes/community-management',
        name: 'classes_community_management',
        meta: {
          icon: '_xiaoquguanli',
          title: 'classes_community_management',
          access: ['community-list']
        },
        component: () => import('@/views/classes/CommunityManagement')
       },
      {
        path: '/classes/coach-calendar',
        name: 'classes_coach_calendar',
        meta: {
          icon: '_rili',
          title: 'classes_coach_calendar',
          access: ['coach-calendar-list']
        },
        component: () => import('@/views/classes/CoachCalendar')
       }
    ]
  },
  {
    path: '/backend',
    name: 'backend',
    component: Main,
    meta: {
      icon: '_yunyingpeizhi',
      title: 'backend',
      access: ['course-plan-query', 'rights-card-query', 'sys_config_nauth_query']
    },
    children: [
      {
        path: '/backend/course-plan',
        name: 'backend_course_plan',
        meta: {
          icon: '_beikejiaoan',
          title: 'backend_course_plan',
          access: ['course-plan-query']
        },
        component: () => import('@/views/backend/CoursePlan')
       },
      {
        path: '/activity/interest-card',
        name: 'activity_interest_card',
        meta: {
          icon: '_quanyiqia',
          title: 'activity_interest_card',
          access: ['rights-card-query']
        },
        component: () => import('@/views/activity/InterestCard')
       },
      {
        path: '/backend/app_coach_agreement_config',
        name: 'app_coach_agreement_config',
        meta: {
          icon: '_bianji',
          title: 'app_coach_agreement_config',
          access: ['sys_config_nauth_query']
        },
        component: () => import('@/views/configuration/AppCoachAgreementConfig')
       },
      {
        path: '/backend/app_coach_notes_config',
        name: 'app_coach_notes_config',
        meta: {
          icon: '_bianji',
          title: 'app_coach_notes_config',
          access: ['sys_config_nauth_query']
        },
        component: () => import('@/views/configuration/AppCoachNotesConfig')
       }
       
    ]
  },
  {
    path: '/financial',
    name: 'financial',
    component: Main,
    meta: {
      icon: '_zhanghuliushui',
      title: 'financial',
      access: ['withdraw_query', 'pay-list', 'report_lesson_order_settlement', 'lesson_settlement_query', 'wallet-query']
    },
    children: [   
      {
        path: '/financial/withdraw/list',
        name: 'financial_withdraw_list',
        meta: {
          icon: '_tixian',
          title: 'financial_withdraw_list',
          access: ['withdraw_query']
        },
        component: () => import('@/views/financial/WithdrawList')
       },
       {
        path: '/financial/wallet/list',
        name: 'financial_wallet_list',
        meta: {
          icon: '_spellList',
          title: 'financial_wallet_list',
          access: ['wallet-query']
        },
        component: () => import('@/views/financial/WalletList')
       },
       {
        path: '/financial/wallet/coach-list',
        name: 'financial_wallet_coach_list',
        meta: {
          icon: '_spellList',
          title: 'financial_wallet_coach_list',
          access: ['wallet-query']
        },
        component: () => import('@/views/financial/WalletCoachList')
       },
       {
        path: '/order/pay',
        name: 'order_pay_detail',
        meta: {
          icon: '_dingdanliushuiicon',
          title: 'order_pay_detail',
          access: ['pay-list']
        },
        component: () => import('@/views/order/PayDetail')
       },
        {
        path: '/order/account-detail',
        name: 'order_account_detail',
        meta: {
          icon: '_dingdanliushuiicon',
          title: 'order_account_detail',
          access: ['report_lesson_order_settlement']
        },
        component: () => import('@/views/order/AccountDetail')
       },
        {
        path: '/order/settlement-detail',
        name: 'settlement_detail',
        meta: {
          icon: '_dingdanliushuiicon',
          title: 'settlement_detail',
          access: ['lesson_settlement_query']
        },
        component: () => import('@/views/order/SettlementDetail')
       }
    ]
  },
  {
    path: '/data',
    name: 'data_detail',
    component: Main,
    meta: {
      icon: '_shujumingxi1',
      title: 'activity_management',
      access: ['rights-card-order-query', 'lesson-order-list']
    },
    children: [
      {
        path: '/order/rights-cards',
        name: 'order_rights_cards',
        meta: {
          icon: '_dingdanliushuiicon',
          title: 'order_rights_cards',
          access: ['rights-card-order-query']
        },
        component: () => import('@/views/order/RightsCards')
       },
        {
        path: '/order/lessons',
        name: 'order_lessons',
        meta: {
          icon: '_dingdanliushuiicon',
          title: 'order_lessons',
          access: ['lesson-order-list']
        },
        component: () => import('@/views/order/Lessons')
       }
    ]
  },
  {
    path: '/report',
    name: 'report',
    component: Main,
    meta: {
      icon: '_tongjibaogao',
      title: 'report',
      access: ['report_lesson_count_by_creator']
    },
    children: [   
      {
        path: '/report/lesson/count',
        name: 'report_lesson_count',
        meta: {
          icon: '_tongjibaogao',
          title: 'report_lesson_count',
          access: ['report_lesson_count_by_creator']
        },
        component: () => import('@/views/report/LessonCount')
       }
    ]
  },
  {
    path: '/system',
    name: 'system_management',
    component: Main,
    meta: {
      icon: '_xitongpeizhi',
      title: 'activity_management',
      access: ['sys-user-query', 'query-role', 'course-type-query','coach-level-list', 'sys_config_query', 'operation_log_query']
    },
    children: [
      {
        path: '/system/user',
        name: 'system_user_list',
        meta: {
          icon: '_guanliyuan',
          title: 'system_user_list',
          access: ['sys-user-query']
        },
        component: () => import('@/views/system/UserList')
       },
       {
        path: '/system/role',
        name: 'system_role_list',
        meta: {
          icon: '_jiaoseguanli',
          title: 'system_role_list',
          access: ['query-role']
        },
        component: () => import('@/views/system/RoleList')
       },
       {
        path: '/system/operation-Logs',
        name: 'operation_Logs',
        meta: {
          icon: '_rizhi',
          title: 'operation_Logs',
          access: ['operation_log_query']
        },
        component: () => import('@/views/operation/Logs')
       },
       {
         path: '/classes/course-category',
         name: 'classes_course_category',
         meta: {
           icon: '_leibie',
           title: 'classes_course_category',
           access: ['course-type-query']
         },
         component: () => import('@/views/classes/CourseCategory')
        },
       {
        path: '/system/coach-level',
        name: 'operator_coach_level',
        meta: {
          icon: '_dengji',
          title: 'operator_coach_level',
          access: ['coach-level-list']
        },
        component: () => import('@/views/operator/CoachLevelManagement')
       },
             {
        path: '/system/app_registration_agreement_config',
        name: 'app_registration_agreement_config',
        meta: {
          icon: '_bianji',
          title: 'app_registration_agreement_config',
          access: ['sys_config_query']
        },
        component: () => import('@/views/configuration/AppRegistrationAgreementConfig')
       },
             {
        path: '/system/app_privacy_agreement_config',
        name: 'app_privacy_agreement_config',
        meta: {
          icon: '_bianji',
          title: 'app_privacy_agreement_config',
          access: ['sys_config_query']
        },
        component: () => import('@/views/configuration/AppPrivacyAgreementConfig')
       },
      {
        path: '/system/app_lesson_agreement_config',
        name: 'app_lesson_agreement_config',
        meta: {
          icon: '_bianji',
          title: 'app_lesson_agreement_config',
          access: ['sys_config_query']
        },
        component: () => import('@/views/configuration/AppLessonAgreementConfig')
       },
      {
        path: '/system/banner_config',
        name: 'banner_config',
        meta: {
          icon: '_bianji',
          title: 'banner_config',
          access: ['sys_config_query']
        },
        component: () => import('@/views/configuration/BannerConfig')
       },
      {
        path: '/system/parameter_config',
        name: 'sys_parameter_config',
        meta: {
          icon: '_bianji',
          title: 'sys_parameter_config',
          access: ['sys_config_query']
        },
        component: () => import('@/views/configuration/SysParameterConfig')
       },
    ]
  },
  {
    path: '/my',
    name: 'my_management',
    component: Main,
    meta: {
      icon: '_wode1',
      title: 'my_management',
      access: ['withdraw_query', 'wallet-query']
    },
    children: [
      {
        path: '/my/wallet',
        name: 'my_wallet_list',
        meta: {
          icon: '_yue',
          title: 'system_user_list',
          access: ['wallet-query']
        },
        component: () => import('@/views/my/WalletList')
       },
       {
        path: '/my/withdraw',
        name: 'my_withdraw_list',
        meta: {
          icon: '_tixian',
          title: 'system_user_list',
          access: ['withdraw_query']
        },
        component: () => import('@/views/my/WithdrawList')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true,
      title: ''
    },
    component: () => import('@/views/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true,
      title: ''
    },
    component: () => import('@/views/error-page/500.vue')
  },
  {
    path: "/:pathMatch(.*)*",
    name: 'error_404',
    meta: {
      hideInMenu: true,
      title: ''
    },
    component: () => import('@/views/error-page/404.vue')
  }
]
